export const defaultRatingSettingsLimit = 10
export const defaultPage = 0
export const defaultSort = 'name-asc'

